import { ButtonBase } from '@/components/Button/ButtonBase'
import { useMergeRefs } from '@/hooks/useMergeRefs'
import clsx from 'clsx'
import { forwardRef, ReactNode, useContext } from 'react'
import styles from './Tab.module.scss'
import { TabsContext } from './TabsContext'

export interface TabProps {
  children: ReactNode
  disabled?: boolean
  id: string
  className?: string
}

export const Tab = forwardRef<HTMLButtonElement, TabProps>(
  ({ children, id: propId, disabled, className }, ref) => {
    const {
      direction,
      variant,
      size,
      value: contextValue,
      onChange,
      setTabRefs,
      wrapperId,
      fullWidth,
    } = useContext(TabsContext)
    const mergedRefs = useMergeRefs(ref, (el) => setTabRefs(el as HTMLElement, propId))

    const isSelected = contextValue === propId
    return (
      // TODO: Replace with <button> + resetCSS
      <ButtonBase
        className={clsx(styles.tab, styles[direction], styles[variant], {
          [styles.inverted]: variant === 'transparent-inverted',
          [styles.selected]: isSelected,
          [styles.disabled]: disabled,
          [styles.fullWidth]: fullWidth,
          className,
        })}
        size={size}
        disabled={disabled}
        onClick={() => onChange(propId)}
        ref={mergedRefs}
        aria-selected={isSelected}
        aria-controls={`tablist-${wrapperId}`}
        id={`tab-${wrapperId}-${propId}`}
        tabIndex={isSelected ? 0 : -1}
        role="tab"
      >
        {children}
      </ButtonBase>
    )
  },
)
